import { render } from "./RelayPoints.view.vue?vue&type=template&id=6a39303c"
import script from "./RelayPoints.view.vue?vue&type=script&lang=js"
export * from "./RelayPoints.view.vue?vue&type=script&lang=js"

import "./RelayPoints.view.vue?vue&type=style&index=0&id=6a39303c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__